/**
 * @Author      gx12358
 * @DateTime    2022/4/1
 * @lastTime    2022/4/1
 * @description 环境：开发
 */
export function isDev(): boolean {
  return typeViteEnv('VITE_APP_ENV') === 'dev'
}

/**
 * @Author      gx12358
 * @DateTime    2022/4/1
 * @lastTime    2022/4/1
 * @description 环境：正式
 */
export function isPro(): boolean {
  return typeViteEnv('VITE_USE_MODE') === 'prod'
}

/**
 * @Author      gx12358
 * @DateTime    2022/4/1
 * @lastTime    2022/4/1
 * @description 环境：非开发环境
 */
export function isBuild(): boolean {
  return typeViteEnv('VITE_APP_ENV') !== 'dev'
}

export function typeViteEnv(key: ViteEnvKey) {
  let value = import.meta.env[key]
  if (value) {
    value = (value as string).replace(/\\n/g, '\n')

    value = value === 'true' ? true : value === 'false' ? false : value
  }

  return value
}
